import Insight from './insight';
import React from 'react';

const InsightResults = props => {
  return (
    <div className="insight-results__list">
      {props.items.slice(0, props.page * props.pageSize).map((item, idx) => (
        <Insight key={`item.title-${idx}`} {...item} />
      ))}
    </div>
  );
};

InsightResults.propTypes = {};

export default InsightResults;
